export function dateEqOrAfter(date1: Date, date2: Date): boolean {
    const formattedDate1 = `${date1.getFullYear()}-${date1.getMonth()}-${date1.getDate()}`;
    const formattedDate2 = `${date2.getFullYear()}-${date2.getMonth()}-${date2.getDate()}`;

    if (formattedDate1 === formattedDate2) {
        return false;
    }
    return date1.getTime() <= date2.getTime();
}

export function getMaxDate(date1: Date, date2: Date): Date {
    if (date1.getTime() > date2.getTime()) {
        return date1;
    }
    return date2;
}

export function createMiddayDate(date: Date | string | number): Date {
    const newDate = new Date(date);
    //   newDate.setHours(0, 0, 0, 0);
    return newDate;
}

export function getNextDayFromNow(): Date {
    const date = new Date();
    date.setDate(date.getDate() + 1);
    return date;
}

export function isDate(date): boolean {
    return date && Object.prototype.toString.call(date) === '[object Date]' && !isNaN(date);
}
